// Module
var code = "<div class=nlgHealthCheckerApplicationErrorCountReason> <div class=nlgHealthCheckerApplicationErrorCountReasonName>{{reason.application}}</div> <nlg-health-checker-error-level-count-reason reason=reason.errorLevelCountReason.data></nlg-health-checker-error-level-count-reason> </div>";
// Exports
module.exports = code;